var map = {
	"./art_0106.jpeg": 4540,
	"./art_0128.jpeg": 2065,
	"./art_1850.jpeg": 9255,
	"./art_2165.jpeg": 5422,
	"./art_2293.jpeg": 6975,
	"./art_2360.jpeg": 9269,
	"./art_2519.jpeg": 9465,
	"./art_2739.jpeg": 3747,
	"./art_2753.jpeg": 4910,
	"./art_2889.jpeg": 9677,
	"./art_3168.jpeg": 2422,
	"./art_4402.jpeg": 1705,
	"./art_6842.jpeg": 2311,
	"./art_7150.jpeg": 9103,
	"./art_7832.jpeg": 2231,
	"./austria.jpeg": 1555,
	"./church_0578.jpeg": 7455,
	"./church_0814.jpeg": 3817,
	"./church_1175.jpeg": 6224,
	"./church_1833.jpeg": 3395,
	"./church_1886.jpeg": 2119,
	"./church_2045.jpeg": 3172,
	"./church_2947.jpeg": 9029,
	"./church_3368.jpeg": 7566,
	"./church_3447.jpeg": 2339,
	"./church_3698.jpeg": 246,
	"./church_3828.jpeg": 5541,
	"./church_6500.jpeg": 1543,
	"./church_6949.jpeg": 791,
	"./church_8137.jpeg": 4178,
	"./france.jpeg": 6430,
	"./german.jpeg": 6732,
	"./italy.jpeg": 5953,
	"./netherland.jpeg": 1086,
	"./uk.jpeg": 7682,
	"./vatican.jpeg": 8224,
	"./view_1567.jpeg": 4369,
	"./view_1613.jpeg": 6550,
	"./view_2184.jpeg": 1142,
	"./view_2813.jpeg": 2770,
	"./view_3884.jpeg": 8709,
	"./view_3957.jpeg": 629,
	"./view_4280.jpeg": 572,
	"./view_4443.jpeg": 7788,
	"./view_4723.jpeg": 3087,
	"./view_5183.jpeg": 2076,
	"./view_6798.jpeg": 5563,
	"./view_6833.jpeg": 4409,
	"./view_8282.jpeg": 2272,
	"./view_9860.jpeg": 6458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;